import { PaginateResult } from "core/resources/types/shared";
import http from "infra/http";
import { useQuery } from "react-query";
import { DocumentoItem, UseDocumentosParams } from 'core/features/documentos/typings';

function useDocumentosUnidade({
  documentoPaiId,
  unidadeId,
  page,
}: UseDocumentosParams) {
  return useQuery(
    `/v1/unidade/${unidadeId}/documento?documentoPaiId=${documentoPaiId}&page=${page}`,
    async () => {
      const { data } = await http.get<PaginateResult<DocumentoItem>>(
        `/v1/unidade/${unidadeId}/documento`,
        {
          params: {
            documentoPaiId,
            page,
          },
        }
      );

      return data;
    }
  );
}

export default useDocumentosUnidade;
